import { makeStyles } from "@material-ui/core/styles";
import { secondary } from "../../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  row: {
    height: "96px",
    minWidth: "300px",
  },
  minContent: {
    minWidth: "max-content",
  },
  iconInfo: {
    marginLeft: theme.spacing(1),
    color: secondary,
    cursor: "pointer",
  },
}));

export default useStyles;
